import { render, staticRenderFns } from "./gradeManagement.vue?vue&type=template&id=5fa3dc7e&scoped=true"
import script from "./gradeManagement.vue?vue&type=script&lang=js"
export * from "./gradeManagement.vue?vue&type=script&lang=js"
import style0 from "./gradeManagement.vue?vue&type=style&index=0&id=5fa3dc7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3dc7e",
  null
  
)

export default component.exports